export type Color = 'inherit' | 'primary' | 'secondary' | 'default' | 'error' | 'info' | undefined;
export const STATE_OPTIONS = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
];
export const DOCUMENT_OPTIONS = ['CPF', 'CNS'];

export enum COLOR_ETHNICITY {
  NaoInformado = 'Condição étnico-racial declarada pelo paciente ou responsável',
  Branca = 'Branca',
  Preta = 'Preta',
  Parda = 'Parda',
  Amarela = 'Amarela',
  Indígena = 'Indígena',
}

export const EXAM_PERIOD_OPTIONS = ['Rotina', 'Urgente', 'Em 30 dias', 'Data específica'];

export const EXAM_RECURRENCE_OPTIONS = ['Não se repete', 'Repete em 1 mês', 'Data específica'];
